import * as Sentry from '@sentry/vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import PresentationApi from '@/api/presentation'
import SlideApi from '@/api/slide'
import Constant from '@/constant'
import Util from '@/util'
import EventBus from '@/eventBus'

import Socket from '@/socket'

import gaCategories from '@/constant/gaCategories'
import { DefaultCanvasBlocks, _migrateDefaultBlockIds } from '@/utils/CanvasBlocksLayout'
import HeadingAndSubLayout from '@/utils/canvas-block-layouts/HeadingAndSubLayout'
import ImageLayout from '@/utils/canvas-block-layouts/ImageLayout'
import { copyBackgroundCacheToSlides } from '../../utils/indexedDB/image.cache.utils'

const RIGHT_SIDE = 'right-side'

export default {
  data() {
    return {
      defaultScale: {
        highLabel: this.$t('Strongly agree'),
        lowLabel: this.$t('Strongly disagree'),
        highValue: 5,
        lowValue: 1,
        0: '',
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
        6: '',
        7: '',
        8: '',
        9: '',
        showAverage: false,
        mustRate: true,
        showMidValues: false,
      },
    }
  },
  watch: {
    '$store.state.presentation.language': function watchChangeLanguage() {
      this.defaultScale.highLabel = this.$t('Strongly agree')
      this.defaultScale.lowLabel = this.$t('Strongly disagree')
    },
  },
  computed: {
    ...mapGetters(['abTestGroup']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,

    }),

  },
  methods: {
    ...mapActions(['setSlideActiveAction', 'checkSlideMovingDirectionAction', 'setSyncLoadingAction', 'patchSlideByIdAction']),
    async selectSlideType({ item, property }) {
      const { slideActive } = this.$store.state

      if (this.$store.state.isNewPresentation) {
        this.$store.state.isNewPresentation = false
        const allHideResultTypes = [
          'multipleChoice',
          'imageChoice',
          'openEnded',
          'wordCloud',
        ]

        allHideResultTypes.forEach((type) => {
          if (item.type === type) {
            slideActive.hideResult = false
          }
        })
      }
      let addCorrectOption = false
      if (slideActive.addCorrectOption) {
        addCorrectOption = true
      }

      if (item.type === 'pickAnswer') {
        addCorrectOption = true
        this._updatePresentation({
          socketId: Socket.getSocketId(),
        })
      }

      if (slideActive.type && slideActive.type != 'voiceQA') {
        this._handleUpdateSlide(item, addCorrectOption, property)
        return
      }

      if (!slideActive.id) {
        await this._handleCreateNewSlide(item, addCorrectOption)
      }

      if (slideActive.id && !slideActive.type) {
        this._handleUpdateSlide(item, addCorrectOption, property)
      }

      // Track choose question type when slide first created
      this._trackGASelectSlideType(item, property)
    },

    async _handleCreateNewSlide(item, addCorrectOption) {
      if (item.type === 'document') {
        EventBus.$emit('openImport')
        Util.gaTrackEvent(
          'Presentation Editing',
          'Open import',
          'Open modal import',
        )
        return
      }

      item.isLoading = true
      this.allTypeSections.push()

      await this._createNewSlide(item, addCorrectOption)
    },

    async _createNewSlide(item, addCorrectOption) {
      try {
        const dataPayload = this._getPayloadCreateNewSlide(item, addCorrectOption)
        const res = await SlideApi.createNewSlide(dataPayload)
        this._handleAfterCreateNewSlide(item, res)
      } catch (error) {
        Util.handleError(error.body ? error.body.message : error)
      }
    },

    _getPayloadCreateNewSlide(item, addCorrectOption) {
      const dataPayload = {
        presentationId: this.presentation.id,
        type: item.type,
        order: this.slideActive.order,
        typeChart: this.slideActive.typeChart,
        socketId: Socket.getSocketId(),
        addCorrectOption,
        slideType: item.slideType,
        textColour: this.slideActive.textColour || '#313131',
        baseColour: this.slideActive.baseColour || '#ffffff',
        backgroundImage: this.slideActive.backgroundImage,
        visibility: this.slideActive.visibility,
      }
      if (item.type === 'pickAnswer') {
        dataPayload.audioAutoPlay = true
      } else if (item.type === 'scale') {
        dataPayload.scale = this.defaultScale
      }

      // Convert Heading/Image slide to Content slide
      if (item.type === 'textSlide' || item.type === 'image') {
        dataPayload.type = 'freestyle'
      }

      // Add default heading blocks
      if (item.type === 'textSlide') {
        dataPayload.canvasBlocks = HeadingAndSubLayout.build()
      }

      // Add default image blocks
      if (item.type === 'image') {
        dataPayload.canvasBlocks = ImageLayout.build()
      }

      return dataPayload
    },

    _handleAfterCreateNewSlide(item, res) {
      res.body.activeTab = 2
      res.body.typeObj = this._getSlideType(item)
      res.body.additionalFields = this._parseStringArrayData(
        res.body.additionalFields,
      )
      res.body.otherCorrectQuiz = this._parseStringArrayData(
        res.body.otherCorrectQuiz,
      )
      if (res.body.type === 'freestyle' && !res.body.canvasBlocks) {
        res.body.canvasBlocks = DefaultCanvasBlocks(res.body.id)
      }
      if (this.slideActive.backgroundCache) {
        copyBackgroundCacheToSlides(this.slideActive, [res.body])
      }

      for (
        let i = 0;
        i < this.presentation.slides.length;
        i++
      ) {
        if (
          !this.presentation.slides[i].id &&
                this.presentation.slides[i].index ==
                  this.slideActive.index
        ) {
          this.presentation.slides[i] = res.body
          this.presentation.slides.push()
          break
        }
      }
      this.setSlideActiveAction(res.body)
      if (res.body.type === 'freestyle') {
        // Cập nhật lại canvasBlock cho Slide Content
        this.patchSlideByIdAction(res.body)
      }
      this.presentation.type = item.type
      this.presentation.slideActive = res.body.id
      item.isLoading = false
      item.id = res.body.id
      this.allTypeSections.push()
      this.setSyncLoadingAction(1)
      if (res.body.type === 'googleSlides') {
        EventBus.$emit('eventHandleSetValueTransition')
      }
      EventBus.$emit('handleHoverOnSlideType', item, 'out', RIGHT_SIDE)

      this._updateNextSlide(res)
      this.checkSlideMovingDirectionAction(this.slideActive.id)

      if (item.type === 'pickAnswer') {
        EventBus.$emit('addSlideLeaderboard')
      }

      EventBus.$emit('sortSlidePresentation')
    },

    async _updateNextSlide(createdSlideResponse) {
      try {
        const payload = {
          activeSlide: createdSlideResponse.body.id,
          presentationId: this.presentation.id,
          accessCode: this.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          sharePresentation: this.sharePresentation,
        }
        await SlideApi.updateNextSlideById(this.$route.params.id, payload)
        this.setSyncLoadingAction(2)
      } catch (error) {
        this.setSyncLoadingAction(3)
        if (Sentry && error.status) {
          Sentry.captureException(
            `Presenter put next slide right side, status: ${error.status}`,
          )
        }
      }
    },

    _trackGASelectSlideType(item, property) {
      let typeGa = item.type
      if (item.slideType) {
        typeGa = `${item.type} ${item.slideType}`
      }
      if (item.type === 'multipleChoice' || item.type === 'imageChoice') {
        typeGa = 'Poll'
      }
      if (item.type === 'freestyle') {
        typeGa = 'Content'
      }

      let subType
      if (item.type === 'textSlide' || item.type === 'image') {
        typeGa = 'Content'
        subType = item.type
      }
      Util.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Create new slide', `${property === 'side-right'
        ? 'Right Column'
        : 'Pop-up Search Slide'}`, typeGa, { slideType: typeGa, slideId: item.id, subType })
    },

    async _updatePresentation(payload) {
      await PresentationApi.updatePresentationByPresentationId(this.presentation.id, payload)
    },

    async _handleUpdateSlide(item, addCorrectOption, property) {
      item.isLoading = true
      this.allTypeSections.push()
      const payload = this._setPayloadUpdateSlide(item, addCorrectOption)

      this._updateSlide(item, payload, property)
    },

    _setPayloadUpdateSlide(item, addCorrectOption) {
      let payload = {
        type: item.type,
        presentationId: this.presentation.id,
        accessCode: this.presentation.uniqueAccessCode,
        uniqueAccessCode: this.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
        addCorrectOption,
        slideType: item.slideType,
      }
      if (item.type === 'pickAnswer') {
        payload.showPercentage = false
        payload.hideResult = false
        payload.showCorrectOption = false
        payload.stopSubmission = false
        payload.multipleChoice = this.slideActive.multipleChoice
        this.slideActive.hideResult = false
        this.slideActive.showCorrectOption = false
        this.slideActive.stopSubmission = false
        this.slideActive.showPercentage = false
      } else if (
        item.type === 'image' &&
          this.slideActive.subheading &&
          this.slideActive.subheading.length > 80
      ) {
        payload.subheading = this.slideActive.subheading.substr(0, 80)
      }

      if (item.type === 'scale' && !this.slideActive.scale) {
        payload.scale = this.defaultScale
      }
      if (
        this.slideActive.type === 'document' &&
          this.slideActive.image
      ) {
        payload.backgroundImage = this.slideActive.image.name
        payload.image = null
      }
      // Convert Heading/Image -> Content slide

      if (item.type === 'textSlide' || item.type === 'image') {
        payload.type = 'freestyle'
      }

      if (item.type === 'textSlide') {
        payload.canvasBlocks = HeadingAndSubLayout.build()
      }
      if (item.type === 'image') {
        payload.canvasBlocks = ImageLayout.build()
      }

      payload.presenting = this.$store.getters.isPresenting
      const migrationPayload = this._handleSetPayloadCanvasBlocks(item, this.slideActive)
      payload = {
        ...payload,
        canvasBlocks: payload.canvasBlocks || migrationPayload.canvasBlocks,
      }
      return payload
    },

    _handleSetPayloadCanvasBlocks(slideSelected, slideActive) {
      // If the slide used to have canvasBlocks -> return rightaway
      if (slideActive.canvasBlocks) {
        return slideActive
      }

      // Convert other slide types to content
      const payload = {}
      if (slideSelected.type === 'freestyle') {
        payload.canvasBlocks = DefaultCanvasBlocks(slideActive.id)
        const headingBlock = Object.keys(payload.canvasBlocks)[0]
        const bodyBlock = Object.keys(payload.canvasBlocks)[1]
        const align = slideActive.textAlign || 'center'

        const noTitle = !slideActive.title
        const noSubheading = !slideActive.subheading
        const noDescription = !slideActive.titleDesc
        const noSlideOptions = !slideActive.SlideOptions ||
          !slideActive.SlideOptions.length ||
          slideActive.SlideOptions.every((option) => !option.title)

        // If the original slide has no content -> return the default blocks right away
        if (noTitle && noSubheading && noDescription && noSlideOptions) {
          return payload
        }

        // set title to the Heading block if any
        if (!noTitle) {
          if (slideActive.titleHTML && slideActive.title !== slideActive.titleHTML) {
            payload.canvasBlocks[headingBlock].content.value = slideActive.titleHTML.replace(slideActive.title, `<strong>${slideActive.title}</strong>`)
          } else {
            payload.canvasBlocks[headingBlock].content.value = `<p style="text-align: ${align}; font-size: 40px;" data-mce-style="text-align: ${align}; font-size: 40px;"><strong>${slideActive.title}</strong></p>`
          }
        } else {
          delete payload.canvasBlocks[headingBlock]
        }

        // set subheading or description to the Body block if any
        if (!noSubheading || !noDescription) {
          let bodyContent = slideActive.subheading || slideActive.titleDesc
          const hasNewLine = /\r|\n/.exec(bodyContent)
          if (hasNewLine && hasNewLine.input) {
            bodyContent = hasNewLine.input.replace(/\r|\n/g, '<br>')
          }
          payload.canvasBlocks[bodyBlock].content.value = `<p style="text-align: ${align};" data-mce-style="text-align: ${align};">${bodyContent}</p>`
        } else if (!noSlideOptions) {
          // set slideOptions
          const optionsHTML = this._getOptionsHTML(slideActive.SlideOptions)
          const newContent = `<ul>${optionsHTML}</ul>`
          if (payload.canvasBlocks[bodyBlock].content.value.includes('Click to add')) {
            payload.canvasBlocks[bodyBlock].content.value = newContent
          } else {
            payload.canvasBlocks[bodyBlock].content.value = `${payload.canvasBlocks[bodyBlock].content.value}${newContent}`
          }
        } else {
          delete payload.canvasBlocks[bodyBlock]
        }
      }
      return payload
    },

    _getOptionsHTML(options) {
      let text = ''
      options.forEach((option) => {
        text = `${text}<li>${option.title ? option.title : ''}</li>`
      })
      return text
    },

    async _updateSlide(item, payload) {
      try {
        const res = await SlideApi.updateSlideById(this.slideActive.id, payload)
        const [, [slideData], slideOptions] = res.body
        slideData.additionalFields = this._parseStringArrayData(
          slideData.additionalFields,
        )
        slideData.otherCorrectQuiz = this._parseStringArrayData(
          slideData.otherCorrectQuiz,
        )
        slideData.activeTab = 2
        slideData.typeObj = this._getSlideType(slideData)
        slideData.multipleCountAnswer = this.slideActive.multipleCountAnswer
        slideData.voteCache = this.slideActive.voteCache
        if (slideOptions) {
          slideData.SlideOptions = slideOptions
        } else {
          slideData.SlideOptions = this.slideActive.SlideOptions
        }

        const allSlides = this.presentation.slides
        const cachedSlide = allSlides.find((t) => t.id === this.slideActive.id)
        if (cachedSlide) {
          let canvasBlockData = cachedSlide.canvasBlocks
          if (!canvasBlockData && !cachedSlide.canvasBlocksUrl) {
            canvasBlockData = DefaultCanvasBlocks(this.slideActive.id)
          }
          slideData.canvasBlocks = canvasBlockData
        }
        slideData.canvasBlocks = _migrateDefaultBlockIds(payload.canvasBlocks, slideData.id)

        item.isLoading = false
        this.setSlideActiveAction(slideData)
        EventBus.$emit('eventHandleSetValueTransition')
        EventBus.$emit('handleHoverOnSlideType', item, 'out', RIGHT_SIDE)

        const indexSlide = this.presentation.slides.findIndex(
          (slide) => {
            return slide.id == slideData.id
          },
        )
        this.presentation.slides[indexSlide] = slideData

        this.presentation.slides.push()
        if (item.type === 'pickAnswer') {
          if (
            this.presentation.slides.length - 1 > indexSlide &&
                this.presentation.slides[indexSlide + 1].type !=
                  'leaderboard'
          ) {
            EventBus.$emit('addSlideLeaderboard')
          } else if (this.presentation.slides.length - 1 == indexSlide) {
            EventBus.$emit('addSlideLeaderboard')
          }
        }
        this._handleTrackGAUpdateSlide(item)
      } catch (error) {
        //
      }
    },

    _getSlideType(slide) {
      if (!slide.slideType) slide.slideType = null
      let obj = {}
      Constant.allTypeSections.forEach((item) => {
        item.slideTypes.forEach((typeObj) => {
          if (!typeObj.slideType) typeObj.slideType = null
          if (
            typeObj.type === slide.type &&
            typeObj.slideType === slide.slideType
          ) {
            obj = typeObj
          }
        })
      })
      return obj
    },

    _parseStringArrayData(stringData) {
      let jsonArrayData = []
      if (stringData && typeof stringData === 'string') {
        jsonArrayData = JSON.parse(stringData)
      }
      return jsonArrayData
    },

    _handleTrackGAUpdateSlide(item) {
      let typeGa
      if (item.type !== 'ideas') {
        typeGa = item.type
      }
      if (item.type === 'ideas') {
        typeGa = 'brainstorm'
      }
      if (item.type === 'multipleChoice' || item.type === 'imageChoice') {
        typeGa = 'poll'
      }
      if (item.type === 'freestyle') {
        typeGa = 'Content'
      }
      if (item.slideType) {
        typeGa = `${item.type} ${item.slideType}`
      }
      // Track change question type
      Util.gaTrackEvent(
        Constant.gaCategories.PRESENTATION_EDITOR,
        'Side right > Choose slide type',
        typeGa,
        null,
        {
          slideId: this.slideActive.id,
          slideType: typeGa,
        },
      )
    },
  },
}
